import {IHome} from './interfaces';

const PATH = {
  DASHBOARD: '/admin',
  MY_ADMIN: '/my/home',
  ID_ADMIN: '/id/home',
};

const ROUTES: IHome[] = [
  {
    label: 'Malaysia',
    path: PATH.MY_ADMIN,
    cCode: 'MY',
    mCode: '+60',
    currencyCode: 'MYR',
    currencyAbr: 'RM',
  },
  {
    label: 'Indonesia',
    path: PATH.ID_ADMIN,
    cCode: 'ID',
    mCode: '+62',
    currencyCode: 'IDR',
    currencyAbr: 'Rp',
  },
  {
    label: 'Thailand',
    path: PATH.ID_ADMIN,
    cCode: 'TH',
    mCode: '+66',
    currencyCode: 'THB',
    currencyAbr: '฿',
  },
];

const OPS_JAVA_ENDPOINTS = {
  CTP_DETAILS: '/loanApplications/byCtp',
  CTP_UPLOAD: '/loanApplications/updateCtpByExcel',
  DISBURSE_DETAILS: '/loanApplications/byDisbursement',
  DISBURSE_UPLOAD: '/loanDetail/loan',
  KYC_VIEW: '/loanApplications/byKyb',
  LENDER_DECISION_DETAILS: '/loanApplications/byLenderDecision',
  UPDATE_LENDER_DECISION: '/loanApplications/lenderDecision',
  LENDER_REJECTION_REASONS: '/loanApplications/lenderDecision/rejectionReasons',
  REJECTION_LIST: '/loanApplications/rejectionList',
  APPLICATION_DETAILS: '/loanApplication/list',
  PROFILE: '/profile',
  LOCORE_FULL_PROFILE: '/locore/profile/fullProfile',
  KYC_UPLOAD: '/kybDoc/save',
  GET_KYC: '/kybDoc/download',
  UPDATE_KYB: '/loanApplications/updateKyb',
  PII: '/partner/pii',
  SETTLEMENT: '/settlement',
  DOWNLOAD_TNC: '/tnc/download',
  DOWNLOAD_CTP_CERTIFICATE: '/tnc/ctp/downloadCertificate',
  REPAYMENT_INSTRUCTION: '/loanmanagement/repaymentinstruction/start',
  STOP_REPAYMENT_INSTRUCTION: '/loanmanagement/repaymentinstruction/stop',
  UPLOAD_REPAYMENT: '/loanRepayment/uploadRepaymentTransactions',
  ELIGIBLE_MERCHANTS: '/eligibleMerchants/list',
  NOTIFICATION_SEND: '/notification/send',
  BUCKET_IDENTIFIER_SAVE: '/bucketIdentifier/save',
  GET_BUCKET_IDENTIFIER: '/bucketIdentifier',
  GET_REFUND_LIST: '/loanmanagement/refund',
  UPLOAD_ENROLLMENT_REPORT: '/upload/uploadEnrollmentReport',
  UPLOAD_REFUND_RESULT: '/loanmanagement/refund',
  SEARCH_MERCHANT: '/creditLimit/searchOverrideLimit',
  SELECT_SME_MASKED_ID: '/creditLimit/selectOverrideLimit',
  NEW_LIMIT_PREVIEW: '/creditLimit/previewLimit',
  SAVE_NEW_LIMIT: '/offerRangeCapture/save',
  SELECT_ADVANCE_ID: '/creditLimit/selectOverrideTopUpLimit',
  SAVE_TOPUP_LIMIT: '/creditLimit/saveTopUpLimit',
  LIMIT_HISTORY: '/creditLimit/limitHistory',
  STATEMENT: '/bankStatement/upload',
  SALES: '/sales',
  NONCOMPLETED_ADVANCE: '/loanDetail/nonCompletedLoans',
  LOAN_DETAILS: '/loanDetail/loan',
  UPDATE_FIRST_REPAYMENT_DATE: '/loanDetail/updateExpectedFirstRepaymentDate',
  COLLECTION_LOOKUP: '/loanDetail/collectionsAutomation/lookup',
  COLLECTION_TEMPLATE: '/loanDetail/collectionsAutomation/templates',
  COLLECTION_SEND_LINK: '/notification/sendPaymentLinkNotification',
  COLLECTION_UPLOAD: '/loanDetail/collectionsAutomation/upload',
  COLLECTION_LIST: '/payment-gateway/collection-automation/fetch-payment-link',
  COLLECTION_LINK_REFRESH:
    '/payment-gateway/collection-automation/payment-links/{curlecId}/refresh',
  TOPUP_PREVIEW: '/creditLimit/previewTopUpLimit',
  CAMPAIGN_LIST: '/sfcore/promoCampaign',
  DELETE_CAMPAIGN: '/sfcore/promoCampaign/{campaignId}',
  CAMPAIGN_DETAILS: '/sfcore/promoCampaign/{campaignId}',
  CREATE_CAMPAIGN: '/sfcore/promoCampaign',
  DOWNLOAD_FEE_TNC: '/sfcore/tnc/platformFees/download',
  FACILITY_LETTER_TEMPLATES: '/facility-letter/templates',
  FACILITY_LETTER_DISPATCH: '/loanApplication/facility-letter/regenerate',
  BULK_PAY_SWIFT_CODES: '/bulk-pay/bank-swift-codes',
  GET_PARTNERS: '/eligibleMerchants/partners',
  PREVIEW_DELINK: '/loanApplications/previewSoftRejectDdDeLink',
  EXECUTE_DELINK: '/loanApplications/executeSoftRejectDdDeLink',
  OPS_BOARD_ROWS: '/opsBoard/rows',
  OPS_BOARD_CHECKLIST: '/opsBoard/{loanApplicationId}/checklist',
  OPS_BOARD_CHECKLIST_ITEM:
    '/opsBoard/{loanApplicationId}/checklist/{itemCode}',
  OPS_BOARD_CHECKLIST_ITEM_ENABLE:
    '/opsBoard/{loanApplicationId}/checklist/{itemCode}/enable',
  OPS_BOARD_AUDIT: '/opsBoard/{loanApplicationId}/audit',
  OPS_BOARD_STEP_DEFINITIONS: '/opsBoard/stepDefinitions',
  OPS_BOARD_STEP_DEFINITION_ITEM: '/opsBoard/stepDefinitions/{itemCode}',
  OPS_BOARD_STEP_DEFINITION_ITEM_ACTIVE:
    '/opsBoard/stepDefinitions/{itemCode}/active',
  OPS_BOARD_STEP_DEFINITION_ITEM_MANDATORY:
    '/opsBoard/stepDefinitions/{itemCode}/mandatory',
  OPS_BOARD_STEP_DEFINITION_ITEM_AUDIT:
    '/opsBoard/stepDefinitions/{itemCode}/audit',
  LENDERS_LIST: '/sfcore/lender/list',
  BULK_REFRESH: '/myctp/fetch-status',
  SEND_CTP: '/myctp/send-ctp',
  SKIP_CTP: '/sfcore/loanApplications/skipCtp',
  UPDATE_CTP_ORDER_NUMBER: '/sfcore/loanApplications/updateCtpOrder',
  CREDIT_POCKET_DD_SETUP_INSTRUCTION:
    '/collectionAutomation/credit-pockets/{mpId}/dd-setup-instruction',
  CREDIT_POCKET_ADVANCES:
    '/collectionAutomation/credit-pockets/{mpId}/advances',
  BACKUP_DD_ADVANCE_DETAILS: '/collectionAutomation/backup-dd/advance-details',
  CTOS_DOCUMENT: '/sfcore/loanApplication/ctosDocument',
  REFRESH_SIGNALS: '/sfcore/loanApplication/refreshSignals',
  ONDEMAND_DD_PREVIEW: '/payment-gateway/ondemand/preview',
  ONDEMAND_DD_ENQUEUE: '/payment-gateway/ondemand/enqueue',
  CREDIT_POCKET_DD_MANDATE:
    '/collectionAutomation/credit-pockets/selectCreditPocketDdMandate',
  BACKUP_DD_SWITCH:
    '/collectionAutomation/backup-dd/switch-to-fixed-dd/confirm',
  GET_DISCREPANCY: '/applications/{loanApplicationId}/bank-discrepancy',
  RESOLVE_DISCREPANCY:
    '/applications/{loanApplicationId}/bank-discrepancy/resolve',
  FORM_GENERATED_LINKS: '/locore/leadForm/ops/links',
  EXPORT_LINK_CSV: '/locore/leadForm/ops/links/export',
  SMART_FORM_PARTNERS: '/locore/leadForm/ops/partners',
  UPLOAD_SME_RECORDS: '/locore/leadForm/ops/upload',
  CHECKLIST_PARTNERS: '/sfcore/opsBoard/partners',
  OPS_BOARD_STEP_DEFINITION_ITEM_PARTNERS:
    '/sfcore/opsBoard/stepDefinitions/{itemCode}/partners',
  SIGNAL_REFRESH: '/sfcore/loanApplication/refreshSignals',
};

const OPS_MW_ENDPOINTS = {
  LENDER_REQUEST_CODE: '/api/v1/lender/auth/request-otp',
  LENDER_VERIFY_CODE: '/api/v1/lender/auth/verify-otp',
  LENDER_VIEW_ADVANCES: '/api/v1/lender/auth/view-advances',
  LENDER_VIEW_AMORTIZATION: '/api/v1/lender/auth/view-amortization',
  LENDER_VIEW_FEE_AND_PRINCIPLE: '/api/v1/lender/auth/view-fee-principal',
  LENDER_VIEW_REPAYMENT: '/api/v1/lender/auth/view-repayment',
  LENDER_LOGOUT: '/api/v1/lender/auth/logout',
  LENDER_USER_PERMISSIONS: '/api/v1/lender/auth/user-permissions',
  LENDER_TOKEN_VERIFY: '/api/v1/google/auth/lender-captcha-validation',
};

const AGENT_ENDPOINTS = {
  CTOS_ANALYSIS: '/kyb_workflow',
  CTOS_DECISION: '/manual_decision',
};

const CAI_ENDPOINTS = {
  BANK_SWIFT_CODE: '/be/api/bank-lookup/batch',
};

// API_PARAMS We are using this values in [CtpView api.ts file]
const API_PARAMS = {
  PAGE: 0,
  SIZE: 100,
};

const domainToCountryCodeMap: {[key: string]: string} = {
  'ops.seedflex.com': 'MY',
  'ops.seedflex.id': 'ID',
  'stagingops.seedflex.com': 'MY',
  'stagingops.seedflex.id': 'ID',
  'qa.bizops.seedflex.com': 'MY',
  'qaops.seedflex.id': 'ID',
  'qa.bizops-th.seedflex.com': 'TH',
  'stagingops.jaidee.co.th': 'TH',
  'ops.jaidee.co.th': 'TH',
  'lender.qa.seedflex.com': 'MY',
  'lender.staging.seedflex.com': 'MY',
  'lender.seedflex.com': 'MY',
  localhost: 'ID',
};

const ALLOWED_USERS = [
  'ritwik.ghosh@seedflex.com',
  'sauvik.datta@seedflex.com',
  'shankar.pillai@seedflex.com',
  'joel.ng@seedflex.com',
  'avinash.a@seedflex.com',
  'nova.taner@seedflex.com',
];

const ALLOWED_ADMIN = [
  'avinash.a@seedflex.com',
  'joel.ng@seedflex.com',
  'juinsong.tong@seedflex.com',
  'ritwik.ghosh@seedflex.com',
  'sauvik.datta@seedflex.com',
  'shankar.pillai@seedflex.com',
  'ksheetij.gadhave@seedflex.com',
  'ariel@jaidee.co.th',
];

const OPS_USERS = [
  'linus.lee@seedflex.com',
  'adlyn.zainal@seedflex.com',
  'divani.arumugam@seedflex.com',
  'kishantii.kovan@seedflex.com',
  'jegathisnair.murthy@seedflex.com',
  'afiq.amirul@seedflex.com',
  'aidil.suhairi@seedflex.com',
];

// const ALLOWED_OPS = [
//   'avinash.a@seedflex.com',
//   'joel.ng@seedflex.com',
//   'juinsong.tong@seedflex.com',
//   'ritwik.ghosh@seedflex.com',
//   'sauvik.datta@seedflex.com',
//   'shankar.pillai@seedflex.com',
//   'trixia.wong@seedflex.com',
//   'jegathisnair.murthy@seedflex.com',
//   'navina.r@seedflex.com',
// ];

const domainEnv: {[key: string]: string} = {
  'stagingops.seedflex.com': 'MYSTAGE',
  'stagingops.seedflex.id': 'IDSTAGE',
  'stagingops.jaidee.co.th': 'THSTAGE',
  'ops.seedflex.com': 'MYPROD',
  'ops.seedflex.id': 'IDPROD',
  'ops-th.seedflex.com': 'THPROD',
  'lender.staging.seedflex.com': 'MYSTAGE',
  'lender.seedflex.com': 'MYPROD',
  localhost: 'MYSTAGE',
};

const QA_PERSON = ['kamatchi.ravichandran@seedflex.com'];

const APP_MAP: {[key: string]: string} = {
  lender: 'lender',
  localhost: 'default',
};

export {
  PATH,
  ROUTES,
  OPS_JAVA_ENDPOINTS,
  API_PARAMS,
  domainToCountryCodeMap,
  ALLOWED_USERS,
  ALLOWED_ADMIN,
  domainEnv,
  AGENT_ENDPOINTS,
  QA_PERSON,
  // ALLOWED_OPS,
  OPS_USERS,
  CAI_ENDPOINTS,
  APP_MAP,
  OPS_MW_ENDPOINTS,
};
